import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

const baseStyles = {
    container: {
        flexDirection: 'column'
    },
    headingContainer: {
        justifyContent: 'center',
        width: '100%',
        marginBottom: 0
    },
    heading: {
        ...fontStyles.settingsHeading
    },
    itemsContainer: {
        flexDirection: 'column',
        backgroundColor: Theme.alertTextColor,
        borderWidth: 1,
        borderRadius: 4,
        borderColor: Theme.secondaryButtonBorderColor,
        marginTop: 8
    },
    itemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 180,
        padding: 10
    },
    itemLabelContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    itemContainerWithBorder: {
        borderBottomWidth: 1,
        marginRight:8,
        borderBottomColor: Theme.secondaryButtonBorderColor
    },
    itemLabel: {
        fontSize: 20,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor
    },
    labelIcon: {
        width: 20,
        height: 20,
        marginRight: 5
    },
    iconContainer: {
        width: 20,
        height: 20
    },
    selectedIcon: {
        width: '100%',
        height: '100%'
    }
};

export default StyleSheet.create(baseStyles);
